/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Admin` - ADMIN
 * * `Member` - MEMBER
 * * `Guest` - GUEST
 * * `Technical admin` - TECHNICAL_ADMIN
 * * `Financial admin` - FINANCIAL_ADMIN
 */
export enum UserRole {
  ADMIN = 'Admin',
  MEMBER = 'Member',
  GUEST = 'Guest',
  TECHNICAL_ADMIN = 'Technical admin',
  FINANCIAL_ADMIN = 'Financial admin',
}
